import "../../FhIcon.css";
import { computed, openBlock, createElementBlock, normalizeClass, normalizeStyle } from "vue";
import { SIZES_ENUMS } from "./constants.mjs";
import { ICON_COLORS } from "./colors.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["innerHTML"];
const _sfc_main = {
  __name: "FhIcon",
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: SIZES_ENUMS.SM,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    color: {
      type: String,
      default: "",
      validator: (value) => ["", ...ICON_COLORS].includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const computedColor = computed(() => {
      return props.color && `--icon-color: var(--fh-color-icon-${props.color})`;
    });
    const computedIconClasses = computed(() => {
      return ["fh-icon", `fh-icon--${props.size}`];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(computedIconClasses.value),
        style: normalizeStyle(computedColor.value),
        "aria-hidden": "true",
        innerHTML: props.icon
      }, null, 14, _hoisted_1);
    };
  }
};
const FhIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-790ba507"]]);
export {
  FhIcon as default
};
//# sourceMappingURL=FhIcon.mjs.map
